import { DataField, onFieldValueChange } from '@eastcoal/formily/exports/core'

import { MathOperator } from '@eastcoal/shared/enums/MathOperator'

export const quotaEntitiesEffect = () => {
  onFieldValueChange('quotaEntities.*.type', field => {
    const disabled = field.value !== MathOperator.RANGE
    field
      .query('.value2')
      .take(field => field as DataField)
      .setState(state => {
        state.disabled = disabled
        state.required = !disabled
        if (disabled) state.value = undefined
      })
  })
}
